(function () {
  if (window.__syApp) return; window.__syApp = true;
  var ic = {
    home: '<path d="M4 11l8-7 8 7v9a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z"/>',
    shop: '<rect x="4" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5"/>',
    search: '<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>',
    heart: '<path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.3a4.3 4.3 0 0 1 7.5 2.5C19.5 15.4 12 20 12 20z"/>',
    bag: '<path d="M5 8h14l-1 12H6z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/>'
  };
  function svg(k) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ic[k] + '</svg>'; }
  function init() {
    if (document.querySelector('.sy-tab')) return;
    var p = location.pathname.replace(/\/$/, '') || '/';
    var nav = document.createElement('nav');
    nav.className = 'sy-tab'; nav.setAttribute('aria-label', 'Primary');
    var items = [
      ['home', 'Home', '/', p === '/'],
      ['shop', 'Shop', null, /^\/collections/.test(p) || /^\/products/.test(p)],
      ['search', 'Search', '/search', /^\/search/.test(p)],
      ['heart', 'Saved', null, false],
      ['bag', 'Bag', '/cart', /^\/cart/.test(p)]
    ];
    items.forEach(function (it) {
      var el = document.createElement(it[2] ? 'a' : 'button');
      el.className = 'sy-tab__i' + (it[3] ? ' is-on' : '');
      if (it[2]) el.href = it[2]; else el.type = 'button';
      el.dataset.k = it[0];
      el.innerHTML = svg(it[0]) + '<span>' + it[1] + '</span>' + (it[0] === 'bag' ? '<i class="sy-tab__n"></i>' : '');
      if (it[3]) el.setAttribute('aria-current', 'page');
      nav.appendChild(el);
    });
    document.body.appendChild(nav);
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('.sy-tab__i'); if (!b) return;
      var k = b.dataset.k;
      if (k === 'shop') { e.preventDefault(); var s = document.querySelector('.sy-menu-toggle'); if (s) s.click(); }
      else if (k === 'heart') { e.preventDefault(); var f = document.querySelector('.sy-fav-open'); if (f) f.click(); }
      else if (k === 'bag') {
        var c = document.querySelector('#cart-icon-bubble');
        if (c && !/^\/cart/.test(location.pathname) && document.querySelector('cart-drawer')) { e.preventDefault(); c.click(); }
      }
      if (navigator.vibrate) try { navigator.vibrate(8); } catch (x) {}
    });
    function count() {
      var n = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]') || document.querySelector('#cart-icon-bubble .cart-count-bubble');
      var t = n ? n.textContent.replace(/\D/g, '') : '';
      var el = nav.querySelector('.sy-tab__n'); if (el) el.textContent = t && t !== '0' ? t : '';
    }
    count();
    var cb = document.querySelector('#cart-icon-bubble');
    if (cb) new MutationObserver(count).observe(cb, { subtree: true, childList: true, characterData: true });
    function modal() {
      var open = !!document.querySelector('dialog[open]') || !!document.querySelector('details.sy-drawer[open]');
      document.body.classList.toggle('sy-modal', open);
    }
    new MutationObserver(modal).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    var bar = document.querySelector('.sy-header__bar');
    if (bar && p !== '/') {
      var back = document.createElement('button');
      back.type = 'button'; back.className = 'sy-back'; back.setAttribute('aria-label', 'Go back');
      back.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
      back.addEventListener('click', function () {
        var same = false;
        try { same = document.referrer && new URL(document.referrer).origin === location.origin; } catch (x) {}
        if (same && history.length > 1) history.back();
        else location.href = /^\/products/.test(p) ? '/collections/all' : '/';
      });
      bar.insertBefore(back, bar.firstChild);
    }
    var opener = document.querySelector('.mobile-facets__open, .mobile-facets__open-wrapper summary');
    if (opener) {
      var pill = document.createElement('button');
      pill.type = 'button'; pill.className = 'sy-fpill';
      pill.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h10M18 7h2M4 17h2M10 17h10"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/></svg><span>Filter &amp; Sort</span>';
      pill.addEventListener('click', function () { opener.click(); });
      document.body.appendChild(pill);
      window.addEventListener('scroll', function () {
        var grid = document.querySelector('#product-grid, .collection');
        pill.classList.toggle('is-off', grid ? grid.getBoundingClientRect().top > innerHeight * .6 : false);
      }, { passive: true });
    }
    document.querySelectorAll('input[name*="phone" i],input[type=tel]').forEach(function (i) { i.setAttribute('inputmode', 'tel'); if (!i.autocomplete) i.setAttribute('autocomplete', 'tel'); });
    document.querySelectorAll('input[type=email]').forEach(function (i) { i.setAttribute('inputmode', 'email'); i.setAttribute('autocapitalize', 'off'); });
    document.querySelectorAll('input[type=search]').forEach(function (i) { i.setAttribute('enterkeyhint', 'search'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
